import { KeyPair } from '@wizeoo/akm-compute-lib';
import { WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';

/** une entête de colonne de grid */
export class ColumnHeaderVO {

  /**
   * objet colonne
   * @param keyCode code de la colonne
   * @param keyPairs collection de valeur brute / clé de tri / label
   * @param conf 
   */
  public constructor(keyCode: string, keyPairs?: KeyPair[], conf?: WidgetConfigurationItemObj) {
    this.keyCode = keyCode;
    this.keyPairs = keyPairs;
    this.conf = conf;
  }

  keyCode: string = null; // la clé de champ de la colonne (FIELD#LEVEL)
  keyPairs: KeyPair[] = null; // la collection de valeurs pour cette clé
  conf: WidgetConfigurationItemObj = null; // la conf de la colonne



}
